class SectionInternational extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const $countrySelector = this.querySelector('[data-country-selector]');

      const $countrySelectorOpen = this.querySelector('[data-country-selector-open]');
      $countrySelectorOpen?.addEventListener('click', () => {
        $countrySelector.show();
        document.body.classList.add('country-selector-open');
      });

      const $countrySelectorClose = this.querySelector('[data-country-selector-close]');
      $countrySelectorClose?.addEventListener('click', () => {
        $countrySelector.classList.add('is-closing');

        setTimeout(() => {
          $countrySelector.classList.remove('is-closing');
          document.body.classList.remove('country-selector-open');
          $countrySelector.close();
        }, 500);
      });

      const $columnTogglers = this.querySelectorAll('[data-column-toggler]');
      $columnTogglers.forEach($columnToggler => {
        $columnToggler.addEventListener('click', () => {
          const $column = $columnToggler.closest('[data-column]');
          $column.classList.toggle('is-open');
        });
      });
    }
}

customElements.define('section-international', SectionInternational);